module.exports = __webpack_public_path__ + "media/8.df210d68.wav";